import { ProductDisabledType } from '@/features/YTLive/LiveProducts/getProductDisabledType';

const ytLive = {
  'Learn more': 'Learn more',
  'Field youtubeId': 'YouTube channel ID',
  'Field youtubeUrl': 'YouTube Channel URL',
  'Field brandHomeUrl': 'Store URL',
  'Field date': 'The Expected LIVE Broadcast Time',
  'Field date - description':
    'Please note that your products will only be published in the Google Merchant Center or by the admin of your YouTube channel after you click the "Go Live" button. Once you have completed all the settings above, it is recommended that you conduct a trial broadcast on the YouTube channel three days before the actual broadcast to ensure a successful outcome.\n*Reminder: Due to restrictions on product uploading on YouTube and Google Merchant Center, you can only select a time 24 hours after the current time as your expected live broadcast time.',
  'Live Products': 'Livestream product(s)',
  'Live Products - counter': '({{count}}/{{max}})',
  'Live Products - description':
    'Please provide your expected live broadcast time. After selection, the hidden products will be exposed at your SHOP Storefront & YouTube Channel Admin/Front according to your selected live broadcast time. Reminder: Due to Google Merchant Center and YouTube platform restrictions, after you selected "The Expected Live Broadcast Time", we\'ll no longer open the editing time for 24 hours before your live broadcast.',
  'Live Products - min error':
    'Products are required for live broadcasts. Please select at least one.',
  'Live Products - max error':
    'Only {{count}} products can be added to a LIVE Broadcast Room. Please reduce the number of LIVE Broadcast Products.',
  'Live Products - nav content':
    'Select or create products for your live broadcast',
  'Add Products': 'Add product(s)',
  'Live Products columns - Product': 'Product',
  'Live Products columns - Price': 'Price',
  'Live Products columns - Inventory': 'Available Quantity',
  'Live Products columns - Status': 'Status',
  'Live Products status - reminder on': 'Out-Of-Stock Reminder: ON',
  'Live Products status - reminder off': 'Out-Of-Stock Reminder: OFF',
  'Live Products status - hidden': 'Hidden Product',
  'Live Products status - schedulePublishAt':
    'Scheduled Publish Time: {{date}}',
  'Live Products status - availableStartTime start':
    'Available After: {{date}}',
  'Live Products status - availableStartTime period':
    'Available Time: {{date}}',
  'Live Products status - availableStartTime end':
    'Unavailable Since: {{date}}',
  [`Live Prdoucts disabled_${ProductDisabledType.unpublished}`]: 'Unpublished',
  [`Live Prdoucts disabled_${ProductDisabledType.emptyPrice}`]:
    'Cannot add product without price',
  [`Live Prdoucts disabled_${ProductDisabledType.hiddenPrice}`]:
    'Cannot add hidden price product',
  'LiveProductsPicker - SearchBar placeholder':
    'Search for Product Name or SPU',
  'LiveProductsPicker - No result': 'No Item Found',
  'LiveProductsPicker - No result description':
    'Try to change the keyword or filter',
  'LiveProductsPicker - View selected products':
    'View the Selected Products ({{count}}/{{max}})',
  'LiveProductsPicker - View all products': 'View All Products',
  'Youtube Admin Preparation': 'YouTube channel dashboard setup',
  'Youtube Admin Preparation - nav content':
    'Complete related settings in the YouTube channel',
  'Youtube Admin Preparation StepOne':
    'Set up a channel in YouTube Studio for product display',
  'Youtube Admin Preparation StepOne - description':
    'Once you set up the Google Merchant Center Content API, the products will be automatically uploaded to your Google Merchant Center and the admin for YouTube live shopping. You can go to the YouTube admin to check the products to be displayed in the live broadcast.',
  'Youtube Admin Preparation StepTwo':
    'Mark the products to be displayed in your live broadcast',
  'Youtube Admin Preparation StepTwo - description':
    'You can mark and pin products to the channel during the live broadcast for viewers to watch and shop at the same time',
  'Youtube Admin Preparation StepThree':
    'Schedule a live broadcast and pin products',
  'Youtube Admin Preparation StepThree - description':
    'During your live broadcast, you can highlight featured products with the pin product feature',
  'Finish Setting': 'Almost done!',
  'Finish Setting - description':
    'Once you complete the steps above, you can start your YouTube live shopping broadcast immediately!',
  'Start Streaming': 'Go to YouTube Channel to Start your LIVE Streaming',
  'exceeded the LIVE Broadcast time':
    'This LIVE Broadcast room has expired (exceeded the LIVE Broadcast time), this editing time will not be stored. If you want to start broadcasting, please add a new LIVE Broadcast room.',
  'Youtube Tnc':
    'When setting up this feature, you acknowledge that you are fully aware of the relevant regulations. Please review the <YoutubePrivacyLink></YoutubePrivacyLink> and the related regulations below.',
  'Youtube Privacy': 'YouTube Privacy Policy',
  'Youtube Tnc Detail':
    'By integrating YouTube Shopping, you agree that order data from your online store, originating from YouTube, will be shared with YouTube',
  'Setup Guide YouTube Shopping Setup': 'YouTube Shopping Live Broadcast',
  'Field Channel': 'Channel',
  'Setup Guide Choose Channel Title': 'Select a YouTube Channel',
  'Setup Guide Choose Channel Description':
    'Note: All shop products, including hidden products, will be synced to the linked YouTube channels.',
  'Setup Guide Choose Channel Dropdown Placeholder': 'Select',
  'Setup Guide No Available Channels':
    'The shop is not linked with any YouTube channel.',
  'Setup Now': 'Setup Now',
  'Schedule Live Stream Title': 'Schedule a livestream',
  'Schedule Live Stream Description':
    'Please select a desired time for the livestream. Once selected, the hidden products will be displayed on your online storefront, front page and dashboard of your YouTube channel based on the chosen time.\n*Please note that, due to Google Merchant Center and YouTube restrictions, the livestream time must be set at least 24 hours in advance and cannot be edited within 24 hours of the scheduled time.',
  'Live Stream Products Title': 'Livestream product(s)',
  'Live Stream Products Description':
    'Please select the livestream product. After clicking "Save", the product will be displayed on Google Merchant Center and YouTube dashboard.',
  'YouTube Preparation Title': 'YouTube channel dashboard setup',
  'YouTube Preparation Description':
    'Due to the limitations of YouTube, starting a YouTube livestream from the SHOPLINE Admin is currently not supported. Please stay tuned for more livestreaming feature updates. If you wish to terminate the livestream, please go to your YouTube dashboard to proceed. The following are what you need to know before starting a livestream:',
  'Account Linking YouTube Preparation StepOne':
    '1. Set up a channel in YouTube Studio for product display',
  'Account Linking YouTube Preparation StepOne - description':
    'Once you set up the Google Merchant Center Content API, the products will be automatically uploaded to your Google Merchant Center and YouTube dashboard. You can go to the YouTube dashboard to select the products to be displayed in the channel.',
  'Account Linking YouTube Preparation StepTwo':
    '2. Mark the products to be displayed in your livestream',
  'Account Linking YouTube Preparation StepTwo - description':
    'You can mark and pin products to the channel during the livestream for viewers to watch and shop at the same time.',
  'Account Linking YouTube Preparation StepThree':
    '3. Schedule a livestream and pin products',
  'Account Linking YouTube Preparation StepThree - description':
    'During your livestream, you can highlight featured products with the pin product feature.',
  'Finish YouTube Setting': 'Almost done!',
};

export default ytLive;
